export default "__VITE_ASSET__CbGFAZqv__"